import React from 'react'
import { Table, Typography } from 'antd'
import { ColumnsType } from 'antd/es/table'
import Badge, { TVariant } from 'components/badge/Badge'
import { CampaignProgramListResponseItem } from 'generated/api'
import dayjs from 'dayjs'

interface Props {
  data: CampaignProgramListResponseItem[]
  isLoading: boolean
}

type StatusInfo = {
  translation: string
  type: string
}

const CampaignProgramTable: React.FC<Props> = props => {
  function getStatusInfo(status: string) {
    const statusMapping: { [key: string]: StatusInfo } = {
      SCHEDULED: { translation: 'Dijadwalkan', type: 'warning' },
      ONGOING: { translation: 'Berjalan', type: 'info' },
      FINISHED: { translation: 'Selesai', type: 'success' },
    }

    if (status in statusMapping) {
      return statusMapping[status]
    } else {
      return { translation: 'Selesai', type: 'success' }
    }
  }
  const columnsOrder: ColumnsType<CampaignProgramListResponseItem> = [
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">Tanggal Program</Typography.Text>
        </div>
      ),
      width: '30%',
      dataIndex: 'date',
      key: 'date',
      render: (_, record) => (
        <div className="flex flex-col h-full" data-testid="date">
          <Typography.Text className="font-medium text-gray-800">
            {dayjs(record.startTime).format('DD MMM YYYY, HH:mm')}-
            {dayjs(record.endTime).format('DD MMM YYYY, HH:mm')}
          </Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">Nama Program</Typography.Text>
        </div>
      ),
      dataIndex: 'name',
      key: 'name',
      render: text => (
        <div data-testid="cell_name" className="flex flex-col">
          <Typography.Text className="font-medium text-gray-800">{text}</Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div className="flex w-14">
          <Typography.Text className="font-semibold text-gray-800">Jumlah Peserta</Typography.Text>
        </div>
      ),
      width: '12%',
      dataIndex: 'totalParticipant',
      key: 'totalParticipant',
      render: text => (
        <div data-testid="cell_disbursement" className="flex flex-col">
          <Typography.Text className="font-medium text-gray-800">{text}</Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">Status</Typography.Text>
        </div>
      ),
      dataIndex: 'status',
      key: 'status',
      width: '13%',
      render: text => (
        <div data-testid="cell_status" className="flex flex-col">
          <Badge
            title={getStatusInfo(text)?.translation}
            variant={getStatusInfo(text)?.type as TVariant}
          />
        </div>
      ),
    },
    // {
    //   title: (
    //     <Typography.Text className="font-semibold text-gray-800">
    //       <IconMoreCircle data-testid />
    //     </Typography.Text>
    //   ),
    //   width: '5%',
    //   key: 'action',
    //   render: row => (
    //     <Dropdown
    //       placement="bottomRight"
    //       trigger={['click']}
    //       dropdownRender={() => (
    //         <div
    //           className="flex flex-col gap-3 p-4 bg-white rounded-md shadow-xl"
    //           data-testid="dropdown-detail"
    //         >
    //           <span className="font-semibold pt-2 px-3">Aksi</span>
    //           <span
    //             data-testid="select-detail"
    //             onClick={() => navigate(`/campaign/detail/${row.id}`)}
    //             className="hover:bg-primary py-1 px-3 bg-white cursor-pointer hover:text-white rounded-lg"
    //           >
    //             Lihat Detail
    //           </span>
    //           <span
    //             data-testid="select-detail"
    //             className="hover:bg-primary py-1 px-3 bg-white cursor-pointer hover:text-white rounded-lg"
    //           >
    //             Tambah Peserta
    //           </span>
    //           <span
    //             data-testid="select-detail"
    //             className="hover:bg-primary py-1 px-3 bg-white cursor-pointer hover:text-white rounded-lg"
    //           >
    //             Tambah Target
    //           </span>
    //         </div>
    //       )}
    //       arrow
    //     >
    //       <Button data-testid="button-action" block className="bg-transparent">
    //         <Typography.Text className="font-medium cursor-pointer">
    //           <IconCaretDown />
    //         </Typography.Text>
    //       </Button>
    //     </Dropdown>
    //   ),
    // },
  ]

  return (
    <Table
      rowKey="id"
      loading={props.isLoading}
      data-testid="tbl_campaign_program"
      className="table-primary table-campaign"
      columns={columnsOrder}
      dataSource={props.data}
      pagination={false}
    />
  )
}

export default CampaignProgramTable
